<template>
<div>
  <Navbar/>
  <header>
    <b-container class="py-5">
      <div>
      <h5 class="text-white">Search Results  .. </h5>      
      </div>
      <div>
       </div>

    </b-container>
  </header>
  <section>
    <b-container class="mt-2">
      <b-row v-if="filtered_results.length>0">
         <b-col v-for="(item,i) in filtered_results" :key="i" md="3" cols="12">
              <b-card
                img-alt="Image"
                class="shadow-lg mb-2 d-md-block d-lg-block "
              >
              <b-row>
                 <b-col md="3" class="text-center text-md-left">
                   <img style="border-radius:50%" width="50" height="50" class="img-rounded circle" :src="item.profile_image" alt="">
                 </b-col>
                 <b-col md="8" class="pr-0 text-center text-md-left" >
                <h6>{{item.first_name}} {{item.middle_name}} {{item.last_name}}</h6>
                <span>{{item.specialty}}</span>
                <b-button block size="sm" variant="primary"  @click="$router.push({name: 'UserDetails',params:{selected_user:item}})">View</b-button>

                 </b-col>
              </b-row>

              </b-card>
              <!-- <b-card
                :img-src="item.profile_image"
                img-alt="Image"
                img-height="300"
                
                img-top
                class="shadow-lg mb-2 d-md-none d-lg-none d-block"
              >
                <h6>{{item.first_name}} {{item.middle_name}} {{item.last_name}}</h6>
                <b-button block  variant="primary"  @click="$router.push({name: 'UserDetails',params:{selected_user:item}})">View</b-button>

              </b-card> -->
         </b-col>
      </b-row>
      <div v-else>
       <h5> <i>Coming Soon ..</i> <b-button variant="primary" small pill to="/"> Go back</b-button> </h5> 

      </div>
    </b-container>
  </section>
  <Footer/>
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

import {mapGetters} from 'vuex'
export default {
name: 'SearchResults',
  components: {
    Navbar,
    Footer
  },
  props:['searchquery','filter_state','filter_language','filter_gender'],
  data(){
    return {
      filtered_results:[],
      // related1:['Psychiatrist','Therapist','Psychotherapist','Addiction Specialist',
      // 'Counselor','Psychologist','Social Worker','Marriage/Family Therapist',
      // 'Psychiatric and Mental Health Nurse Practitioner (PMHNP)'],
      related1:['Primary Care Physician (PCP)','Nurse Practitioner','Womens Health Nurse Practitioner (WHNP)',
      'Other','OBGYN'],
      related2:['Individual/Relationship Counseling','Psychologist','Social Worker','Counselor','Marriage/Family Therapist','Psychotherapist','Life Coach','Psychiatrist','Other']
    }
  },
  computed:{
    ...mapGetters(['search_users'])
  },
  watch:{
    search_users(){
      if(this.search_users.length>0){
        this.filtered_results=this.search_users
        this.filterResults()
      }
    }
  },
  created(){
    this.$store.commit("clearSearch",[])
    if(this.searchquery!=null){
      if(this.searchquery!='Other') {
        console.log("Cames")
        if(this.related1.filter(item=>item==this.searchquery).length>0){
          console.log("related 1")
                this.related1.forEach(item=>{
                        this.$store.dispatch('fetchSearchedUsers',item);
                })
        }
        else if(this.related2.filter(item=>item==this.searchquery).length>0){
          console.log("related 2")
          this.related2.forEach(item=>{
                        this.$store.dispatch('fetchSearchedUsers',item);
                })
        }
        else{
      this.$store.dispatch('fetchSearchedUsers',this.searchquery);

        }


      }
      else {
      this.$store.dispatch('fetchOtherSearchedUsers',this.searchquery);

      }
    }
    else{
      this.$router.push({path:'/'})

    }
  },
  methods:{
    filterResults() {
      let state_filter
      // this.filter_state=='Maryland' 
      //  || this.filter_state=='District of Columbia' 
      //  ||this.filter_state=='Virginia',
     if(this.filter_gender!='both'){
       if(this.filter_state=='New Jersey'
       ||this.filter_state=='New York'
       ||this.filter_state=='Connecticut'){


          // && item.languages.find(location=>location==this.filter_language)!=null
         state_filter= this.search_users.map(item=>{
          if(item.location.find(location=>location=='New Jersey' 
           || location=='New York' || location=='Connecticut')!=null 
          && item.gender==this.filter_gender || item.gender=='Non binary'){
            return item
          }  
        })

       }
       else if(this.filter_state=='Maryland' 
       || this.filter_state=='District of Columbia' 
       ||this.filter_state=='Virginia') {

          // && item.languages.find(location=>location==this.filter_language)!=null
         state_filter= this.search_users.map(item=>{
          if(item.location.find(location=>location=='Maryland' 
           || location=='Virginia' || location=='District of Columbia')!=null 
          && item.gender==this.filter_gender || item.gender=='Non binary'){
            return item
          }  
        })
         
       }
       else{
         
          // && item.languages.find(location=>location==this.filter_language)!=null
          state_filter= this.search_users.map(item=>{
          if(item.location.find(location=>location==this.filter_state)!=null 
          && item.gender==this.filter_gender || item.gender=='Non binary'){
            return item
          }  
        })
       }
      
        
     }
     else{
       if(this.filter_state=='New Jersey'
       ||this.filter_state=='New York'
       ||this.filter_state=='Connecticut'){
          state_filter= this.search_users.map(item=>{
            // && item.languages.find(location=>location==this.filter_language)!=null)
            if(item.location.find(location=>location=>location=='New Jersey' 
           || location=='New York' || location=='Connecticut')!=null )
            {
              return item
            }  
          })

       }
       else if(this.filter_state=='Maryland' 
       || this.filter_state=='District of Columbia' 
       ||this.filter_state=='Virginia') {
          state_filter= this.search_users.map(item=>{
            // && item.languages.find(location=>location==this.filter_language)!=null)
            if(item.location.find(location=>location=='Maryland' 
           || location=='Virginia' || location=='District of Columbia')!=null )
            {
              return item
            }  
          })


       }
       else{
          state_filter= this.search_users.map(item=>{
            // && item.languages.find(location=>location==this.filter_language)!=null)
            if(item.location.find(location=>location==this.filter_state)!=null )
            {
              return item
            }  
          })
       }
        
     }
       
      let clean_state_filters= state_filter.filter(item=>item!=null)
      this.filtered_results=clean_state_filters
        
    }
  }
}
</script>

<style>

</style>